import { CandidateEmailCorrespondence } from '../types';

export const sortOnScheduleDate = (
  correspondences: CandidateEmailCorrespondence[]
): CandidateEmailCorrespondence[] => {
  correspondences.sort((a, b) => {
    if (a.scheduledAt && b.scheduledAt) {
      return (
        new Date(b.scheduledAt).getTime() - new Date(a.scheduledAt).getTime()
      ); // Descending order by scheduledAt
    }
    if (a.scheduledAt) {
      return -1; // a comes first if it has scheduledAt and b does not
    }
    if (b.scheduledAt) {
      return 1; // b comes first if it has scheduledAt and a does not
    }
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(); // Descending order by createdAt
  });

  return correspondences;
};
